import DateHandler from '@/shared/utils/date-format';

export default class ContractRuleStatus {
  enabled: boolean;

  competenceStart: string;

  competenceEnd: string;

  constructor(obj: any = {}) {
    this.enabled = obj.enabled;
    this.competenceStart = obj.competenceStart || '';
    this.competenceEnd = obj.competenceEnd || '';
  }

  public static of(obj: any = {}): ContractRuleStatus {
    return new ContractRuleStatus(obj || {});
  }

  public static ofList(obj: any[]): ContractRuleStatus[] {
    return obj.map(this.of);
  }

  get validity(): string {
    return `Vigência: ${DateHandler.localDateToLocal(this.competenceStart)} - 
      ${DateHandler.localDateToLocal(this.competenceEnd)}`
  }
}
